import React, { useState } from 'react';
import { ImageIcon } from 'lucide-react';
import { Input } from '../ui/input';
import { Button } from '../ui/button';
import { MediaPicker } from './MediaPicker';

export const ImagePickField = ({ label, value, onChange, testId }) => {
  const [open, setOpen] = useState(false);
  return (
    <div>
      {label && <label className="text-xs font-medium text-stone-500 mb-1 block">{label}</label>}
      <div className="flex gap-2 items-start">
        {value && <img src={value} alt="" className="w-14 h-14 object-cover rounded border border-stone-200 shrink-0" />}
        <Input value={value ?? ''} placeholder="Image URL or pick from library" onChange={e => onChange(e.target.value)} data-testid={testId} />
        <Button type="button" variant="outline" size="sm" className="h-10 shrink-0" onClick={() => setOpen(true)} data-testid={testId ? `${testId}-library-btn` : undefined}>
          <ImageIcon className="w-4 h-4 mr-1" /> Library
        </Button>
      </div>
      <MediaPicker open={open} onOpenChange={setOpen} onSelect={onChange} />
    </div>
  );
};
